import {createContext} from "react";


export const ChatBotContext = createContext(null)